import { useQueryClient } from '@tanstack/react-query';
import { type RfSubscriptionStatus } from './subscriptionService';
import { SUBSCRIPTION_QUERY_KEYS } from './keys';

// Typed read of the rf-subscription-status entry owned by
// useRfSubscriptionStatus. Lives here so SUBSCRIPTION_QUERY_KEYS stays internal
// to api/subscription (ADR-014); non-subscribing because the owner warms this
// key once and it is never invalidated.
const useRfSubscriptionStatusData = (
  assetId?: string
): RfSubscriptionStatus | null => {
  const queryClient = useQueryClient();
  return (
    queryClient.getQueryData<RfSubscriptionStatus>(
      SUBSCRIPTION_QUERY_KEYS.rfSubscriptionStatus(assetId)
    ) ?? null
  );
};

export default useRfSubscriptionStatusData;
